/**
 * Created by mugambi on 25/03/17.
 */
export const FETCH_RECEIPTS = 'receipts/FETCH_RECEIPTS'



// WEBPACK FOOTER //
// ./client/store/modules/receipts/mutation-types.js